__turbopack_context__.v({
  "adFloat1": "index-module-scss-module__qki9JW__adFloat1",
  "adFloat2": "index-module-scss-module__qki9JW__adFloat2",
  "adFloat3": "index-module-scss-module__qki9JW__adFloat3",
  "adFloat4": "index-module-scss-module__qki9JW__adFloat4",
  "adsDlDetail": "index-module-scss-module__qki9JW__adsDlDetail",
  "carousel": "index-module-scss-module__qki9JW__carousel",
  "carouselItem": "index-module-scss-module__qki9JW__carouselItem",
  "expansion": "index-module-scss-module__qki9JW__expansion",
  "expansionBox": "index-module-scss-module__qki9JW__expansionBox",
  "expansionLi": "index-module-scss-module__qki9JW__expansionLi",
  "expansionUl": "index-module-scss-module__qki9JW__expansionUl",
  "isAdOrSmm": "index-module-scss-module__qki9JW__isAdOrSmm",
  "largeAdvBox": "index-module-scss-module__qki9JW__largeAdvBox",
  "largeImg": "index-module-scss-module__qki9JW__largeImg",
  "list": "index-module-scss-module__qki9JW__list",
  "movie": "index-module-scss-module__qki9JW__movie",
  "oneImg": "index-module-scss-module__qki9JW__oneImg",
  "oneImgA": "index-module-scss-module__qki9JW__oneImgA",
  "oneImgLi": "index-module-scss-module__qki9JW__oneImgLi",
  "oneImgSub": "index-module-scss-module__qki9JW__oneImgSub",
  "richtext": "index-module-scss-module__qki9JW__richtext",
  "singleAdvModule": "index-module-scss-module__qki9JW__singleAdvModule",
  "text": "index-module-scss-module__qki9JW__text",
  "textAdv": "index-module-scss-module__qki9JW__textAdv",
  "textList": "index-module-scss-module__qki9JW__textList",
  "tileImg": "index-module-scss-module__qki9JW__tileImg",
  "tileImgContainer": "index-module-scss-module__qki9JW__tileImgContainer",
  "tileLi": "index-module-scss-module__qki9JW__tileLi",
});
